<template>
    <div class="modal-card card">
        <form @submit.prevent="onFormSubmit()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Delete Users</h4>
                <!-- Close -->
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div class="card-body">
                <p>Are you sure you want to delete the following users?</p>
                <ul class="list-group list-group-sm">
                    <li v-for="item in users" :key="item.index" class="list-group-item">
                        {{item.name}} ({{item.email}})
                    </li>
                </ul>
            </div>
            <div class="card-footer text-end">
                <button class="btn btn-danger">
                    <div
                        v-if="deleteInProgress"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        >
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else><slot></slot>Delete</div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            error: "",
            user: {},
            users: [],
            deleteInProgress: false
        };
    },
    props: {
       modalData: {
            type: Object,
            default: () => ({})
        }
    },
    name: "DeleteUsers",
    methods: {
        ...mapActions("admin", {
            deleteUser: "deleteUser",
        }),
        async onFormSubmit() {
            this.deleteInProgress = true;
            try {
                for (const user of this.users) {
                    await this.deleteUser(user)
                    if (this.modalData && this.modalData.onDeleteUser && typeof this.modalData.onDeleteUser === 'function') {
                        this.modalData.onDeleteUser(user);
                    }
                }
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                return;
            } finally {
                this.deleteInProgress = false;
            }

            this.$store.dispatch("hideModal");
            this.$store.dispatch("admin/fetchUsers");
        },
    },
    beforeMount() {
        this.users = this.modalData?.rows || [];
    }
};
</script>

<style>
</style>